/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InsertClickoutInput = {|
  listingId: string,
  countryCode?: ?string,
  source?: ?string,
  clientMutationId?: ?string,
|};
export type AggregatesListingClickoutInsertMutationVariables = {|
  input: InsertClickoutInput
|};
export type AggregatesListingClickoutInsertMutationResponse = {|
  +insertClickout: ?{|
    +clientMutationId: ?string
  |}
|};
export type AggregatesListingClickoutInsertMutation = {|
  variables: AggregatesListingClickoutInsertMutationVariables,
  response: AggregatesListingClickoutInsertMutationResponse,
|};
*/


/*
mutation AggregatesListingClickoutInsertMutation(
  $input: InsertClickoutInput!
) {
  insertClickout(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InsertClickoutPayload",
    "kind": "LinkedField",
    "name": "insertClickout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingClickoutInsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggregatesListingClickoutInsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b3a9dabe79700eb51b40e4407835cd4c",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingClickoutInsertMutation",
    "operationKind": "mutation",
    "text": "mutation AggregatesListingClickoutInsertMutation(\n  $input: InsertClickoutInput!\n) {\n  insertClickout(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '34370d4179f8f4b0787cea82a3c8f0aa';

export default node;
